module.exports = __webpack_public_path__ + "static/media/haiwaishenbaoliucheng.bba8d8ef.png";